export enum SimpleStatus {
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
}
